import { render, staticRenderFns } from "./ModalCard.vue?vue&type=template&id=6ff6301e&scoped=true&"
import script from "./ModalCard.vue?vue&type=script&lang=js&"
export * from "./ModalCard.vue?vue&type=script&lang=js&"
import style0 from "./ModalCard.vue?vue&type=style&index=0&id=6ff6301e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff6301e",
  null
  
)

export default component.exports